import React, { useEffect, useState, createContext } from 'react'
import {
  Route,
  Routes,
  useLocation,
  useSearchParams,
  useNavigate,
  Navigate,
} from 'react-router-dom'
import { connect } from 'react-redux'

// pages
import Login from "./components/pages/Login"
import Progress from "./components/pages/Progress"
import Dashboard from "./components/pages/Dashboard"
import NotFound from "./components/pages/NotFound"
// layout
import Header from "./layouts/Header/Header"
import Footer from "./layouts/Footer/Footer"

// components
import CustomModal from './components/molecules/CustomModal'

// actions
import {
  logOutAction,
  loginShaAction
} from './store/sessionDuck'

import {
  gtUser,
  gtStaticContent
} from './utils/helpers'
import { getPrice, sendDataLayer } from './utils/functions'
import { doRedeem } from './utils/helpers'

import './styles/main.scss'
import Selector from './components/pages/Selector'
import TCModal from './components/molecules/TcModal'
import FaqsModal from './components/molecules/FaqsModal'

//import CounterDown from './components/atoms/CounterDown'
// import Toast from './components/molecules/Toast'

export const StateController = createContext(null)

function App({
  error,
  token,
  loggedIn,
  logOutAction
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const [modalOpen, setMdalOpen] = useState({})
  const [notFound, setNotFound] = useState(false)
  const [context, setContext] = useState(false)
  const [staticContent, setStaticContent] = useState({})
  const [autologinPreloader, setAutologinPreloader] = useState(false)

  const [awardSelected, setAwardSelected] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)
  const [redemtionLoading, setRedemtionLoading] = useState(false)
  const [showErrorRedemtion, setShowErrorRedemtion] = useState(false)
  const [showSuccessRedemtion, setShowSuccessRedemtion] = useState(false)
  const [showModalExito, setShowModalExito] = useState(false)
  const [showModalCarulla, setShowModalCarulla] = useState(false)
  const [quantumName, setQuantumName] = useState('')
  const [quantumDoc, setQuantumDoc] = useState('')
  const [department, setDepartment] = useState(false)
  const [city, setCity] = useState(false)
  const [site, setSite] = useState(false)
  const [showTcModal, setShowTcModal] = useState(false)
  const [showFaqsModal, setShowFaqsModal] = useState(false)
  //const [showCounterDown] = useState(true)
  const [endCampaignExito, setEndCampaignExito] = useState(false)
  const [endCampaignCarulla, setEndCampaignCarulla] = useState(false)
  const [showAceleradorLogin, setShowAceleradorLogin] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  // const [showToast, setShowToast] = useState(false)
  // const [winnerMision1, setWinnerMision1] = useState(false)
  const [pages, setPages] = useState([
    { page: 'selector', title: 'Selector', icon: 'icon', sublevel: false, component: <Selector privatePage /> },
    { page: 'progreso', title: 'Progreso', icon: 'icon', sublevel: false, component: <Progress privatePage setShowTcModal={setShowTcModal} /> },
  ])

  let home_page = '/selector'
  useEffect(() => {
    if (context.user && context.user.goal_amount_1 !== null) {
      setPages([
        { page: 'progreso', title: 'Progreso', icon: 'icon', sublevel: false, component: <Progress privatePage setShowTcModal={setShowTcModal} /> },
      ])
    }
  }, [context])

  useEffect(() => {
    const now = new Date();
    const endDate = new Date('2026-04-30T23:59:00');

    if (window.location.pathname === '/' && now <= endDate) { 
      setTimeout(() => {
        setShowAceleradorLogin(true)
      }, 1000)
    }
  }, [])

  useEffect(() => {
    const now = new Date();
    const startDate = new Date('2026-06-15T00:00:00');

    if (now >= startDate) {

      if (context?.user?.segment === 'exito') {
        setEndCampaignExito(true);
      }
      
      if (context?.user?.segment === 'carulla') {
        setEndCampaignCarulla(true)
      }
    }
  }, [context?.user])
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 62)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])


  const pathURL = {
    "tZNsUTFTPw": "progreso",
  }

  const handleTcModal = () => {
    setShowTcModal(true)
  };

  const handleFaqsModal = () => {
    setShowFaqsModal(true)
  };


  const closeLoginModal = () => {
    setAutologinPreloader(false)
    setNotFound(false)
    sendDataLayer({ datalayer: { event: 'invalid_credentials' }, repeat: true })
    localStorage.removeItem('userNotFound')
    window.location.href = '/'
  }

  /*const redirectWinners = () => {
    setEndCampaignExito(false);
    setEndCampaignCarulla(false);
    const botonWinner = document.getElementById("tab-prizes");
    botonWinner.click();
  }*/

  useEffect(() => {
    if (window.location.hash === '#terminos-y-condiciones') {
      setShowTcModal(true);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem('userNotFound')) {
      setNotFound(true)
      sendDataLayer({ datalayer: { event: 'error_login_code', text: 'User not found' }, repeat: true })

      setTimeout(() => {
        localStorage.removeItem('userNotFound')
      }, 3000)
    } else {
      setNotFound(false)
    }
  }, [location])

  useEffect(() => {
    if (searchParams.get('utm_web')) {
      setAutologinPreloader(true)
    }

    if (!localStorage.getItem('storage')) {
      if (window.location.search !== '') {
        console.log("Navegate to:", window.location.search)
        // navigate(window.location.search)
      } else {
        const public_url = pages.find((page) => page.page === location.pathname.replace('/', ''))

        if (public_url) {
          if (!loggedIn && public_url?.component?.props?.privatePage) document.location.href = '/'

        }
      }
    }
  }, [searchParams, error])

  useEffect(() => {
    // const now = new Date();
    // const startDate = new Date('2025-06-27T00:00:00');

    // if(context.tracing && context.tracing.winner_1 === 1) {
    //   setWinnerMision1(true);
    // }
    // if(context.tracing && context.tracing.winner_1 === 1 && now >= startDate) {
    //   setShowToast(true);
    // }
    // const isToastViewed = localStorage.getItem('toastViewed')
    // if (isToastViewed) setShowToast(false)
  }, [context])

  useEffect(() => {

    if (token !== '') {
      gtUser(token).then((user) => {

        if (user?.data) {
          setContext(user.data)


          if (
            user?.data &&
            user?.data?.user?.goal_amount_1 === null &&
            window.location.pathname !== '/selector'
          ) {
            console.log("Sin meta seleccionada")
            setTimeout(() => {
              window.location.href = home_page
            }, 3000)
          }


          if (searchParams.get('pathurl')) {
            const path = pathURL[searchParams.get('pathurl')] || home_page
            let queryparams = ''

            for (const x of searchParams.keys()) {
              if (!(x === "utm_web" || x === 'pathurl')) {
                queryparams += `${x}=${searchParams.get(x)}&`
              }
            }
            queryparams = queryparams.slice(0, queryparams.length - 1)
            console.log(path, queryparams)
            if (
              user?.data &&
              user?.data?.user?.goal_amount_1 === null
            ) {
              setTimeout(() => {
                window.location.href = home_page
              }, 3000)
            }
            else {
              window.location.href = `${path}${(queryparams && queryparams !== '') && '?'}${queryparams}`
            }
          } else if (window.location.pathname !== home_page && window.location.pathname === '/') {
            if (
              user?.data &&
              user?.data?.user?.goal_amount_1 === null
            ) {
              console.log("Sin meta seleccionada")
              setTimeout(() => {
                window.location.href = home_page
              }, 3000)
            } else {
              home_page = '/progreso';
              window.location.href = home_page
            }
          }
        } else if (user.statusCode === 301 && localStorage.getItem('storage') && window.location.pathname === '/') {
          localStorage.removeItem('storage')
          window.location.reload()
        }
        if (user?.statusCode === 301 && window.location.pathname !== '/' && window.location.pathname !== '/dashboard') {
          window.location.href = '/'
        }
      }).catch(() => navigate('/'))

    }
  }, [token])

  useEffect(() => {

    gtStaticContent().then((content) => {
      if (content && content.content) setStaticContent(content.content || {})
     else setStaticContent({})
    })
  }, [])

  const handlerModal = () => {
    if (showConfirm) {
      sendDataLayer({ datalayer: { event: 'cancel_bond', product_name: awardSelected?.name, product_price: awardSelected?.price, index: awardSelected?.index }, repeat: true })
    }
    setShowConfirm(!showConfirm)

  }

  const handlerRedemtion = async () => {
    setRedemtionLoading(true)
    let validator = true
    if (awardSelected.twoStepAuth) {
      console.log("Validar aqui si la fecha es correcta")
      validator = false;
    }

    if (awardSelected.canRedem) {
      if (validator) {
        doRedeem(token, awardSelected.price, awardSelected.id, quantumName, quantumDoc, site?.selected).then((data) => {
          setRedemtionLoading(false)
          setShowConfirm(false)

          if (data && data.status === 200 && data.file) {
            setShowSuccessRedemtion(true)
            sendDataLayer({ datalayer: { event: "redeem_bond", product_name: awardSelected?.name, product_price: awardSelected?.price, index: awardSelected?.index }, repeat: false })


            setTimeout(() => {
              window.location.href = pages
                ? pages.find((page) => page.sublevel).children.find((page) => page.page.includes('redenciones')).page
                : 'mis-redenciones'
            }, 5000)
          } else {
            sendDataLayer({ datalayer: { event: 'exhausted_bond', product_name: awardSelected?.name, product_price: awardSelected?.price, index: awardSelected?.index }, repeat: true })
            setShowErrorRedemtion(true)

          }
        }).catch(error => {
          console.log("ERROR ON REDENTION:", error)
        })
      } else {
        setRedemtionLoading(false)
        setShowConfirm(false)
        setShowErrorRedemtion(true)
        console.log("Validacion no completada.")
      }
    } else {
      setRedemtionLoading(false)
      setShowConfirm(false)
      setShowErrorRedemtion(true)
    }
  }

  return (
    <StateController.Provider
      value={
        {
          setMdalOpen: setMdalOpen,
          context: context,
          staticContent: staticContent,
          pages: pages,
          awardSelected: awardSelected,
          setAwardSelected: setAwardSelected,
          handlerRootModal: handlerModal
        }
      }
    >
      {/* {loggedIn && showToast && winnerMision1 && window.location.pathname === '/progreso' &&
        <Toast
          text={`<strong>¡Todo listo para redimir tu premio!</strong> <a href="#premio">Descarga ya</a> el bono que quieres disfrutar 🤩.`}
          show={setShowToast}
          isTopBar
        />
      } */}
      <CustomModal
        title="Verifica tus datos"
        desc="No logramos validar tus datos. Te invitamos a intentarlo de nuevo; si el error persiste, es probable que esta campaña no aplique para ti."
        cta="Aceptar"
        icon={false}
        primaryAction={
          {
            action: closeLoginModal,
            buttonText: 'Cerrar',
            loading: false
          }
        }
        show={notFound} setShowModal={setNotFound}
      />

      {context.user && context.user.segment === 'exito' &&
      <CustomModal
        title="Gracias por usar tu Tarjeta Éxito Mastercard para tooodo lo que quieres."
        desc={`La campaña llegó a su fin, pronto te estaremos informando si fuiste uno de los 70 ganadores.`}
        cta="Cerrar"
        image="Logo_tarjeta_exito.png"
        show={endCampaignExito} setShowModal={setEndCampaignExito}
        primaryAction={
          {
            buttonText: "Cerrar",
          }
        }
        classN="exitoModalFinal"
        segment="exito"
      />
      }
      {context.user && context.user.segment === 'carulla' &&
      <CustomModal
        title="Gracias por usar tu Tarjeta Carulla Mastercard para tooodo lo que quieres."
        desc={`La campaña llegó a su fin, pronto te estaremos informando si fuiste uno de los 70 ganadores.`}
        cta="Cerrar"
        image="Logo_tarjeta_carulla.png"
        show={endCampaignCarulla} setShowModal={setEndCampaignCarulla}
        primaryAction={
          {
            buttonText: "Cerrar",
          }
        }
        classN="carullaModalFinal"
        segment="carulla"
      />
      }

      <CustomModal
        show={showConfirm}
        setShowModal={setShowConfirm}
        redemtion={true}
        image={awardSelected.image}
        title={`COP ${getPrice(awardSelected.price)}`}
        desc={awardSelected.name}
        twoStepAuth={awardSelected.twoStepAuth}
        location={awardSelected?.location}
        brand_id={awardSelected?.brand_id}
        quantumName={quantumName}
        quantumDoc={quantumDoc}
        setQuantumName={setQuantumName}
        setQuantumDoc={setQuantumDoc}
        department={department}
        city={city}
        site={site}
        setDepartment={setDepartment}
        setCity={setCity}
        setSite={setSite}
        token={token}
        awardSelected={awardSelected}
        primaryAction={
          {
            action: handlerRedemtion,
            buttonText: "Descargar",
            loading: redemtionLoading
          }
        }
        secondaryAction={
          {
            action: handlerModal,
            buttonText: "Cancelar"
          }
        }
        terms={
          {
            termsText: "Términos y condiciones",
            termsLink: "/terminos-y-condiciones"
          }
        }
      />
      <CustomModal
        title="Error en la redención"
        desc={'Ocurrió un error al obtener tu bono. Intentalo de nuevo más tarde.'}
        cta="Aceptar"
        image="image.png"
        show={showErrorRedemtion} setShowModal={setShowErrorRedemtion}
      />
      
      <CustomModal
        title="Redención correcta"
        desc={`Tu bono ha sido descargado. Podrás encontrarlo en la sección <strong></strong>.`}
        cta="Aceptar"
        image="image.png"
        show={showSuccessRedemtion} setShowModal={setShowSuccessRedemtion}
      />

      <CustomModal
        title={`<h3>Del 5 al 12 de diciembre,</h3><p>usa tu Tarjeta Éxito Mastercard en tiendas de <strong>moda y restaurantes.</strong></p>`}
        desc={`<strong>Sumaremos<br/>10% adicional</strong><br/>del valor de tus compras para que<br/>puedas acelerar tu meta y acercarte<br/>a los premios.`}
        cta="Cerrar"
        image="modal-exito-2.png"
        show={showModalExito} setShowModal={setShowModalExito}
        segment={context.user ? context.user.segment : ''}
      />
      <CustomModal
        title={`<h3>Del 5 al 12 de diciembre,</h3><p>usa tu Tarjeta Carulla Mastercard en tiendas de <strong>moda y <br/>restaurantes.</strong></p>`}
        desc={`<strong>Sumaremos<br/>10% adicional</strong><br/>del valor de tus compras para que<br/>puedas acelerar tu meta y<br/>acercarte a los premios.`}
        cta="Cerrar"
        image="modal-carulla-2.png"
        show={showModalCarulla} setShowModal={setShowModalCarulla}
        segment={context.user ? context.user.segment : ''}
      />
      {window.location.pathname === '/' && showAceleradorLogin && (
        <CustomModal
          title={`<h3>¡Hasta el 30 de abril!</h3><p><strong>Regístrate</strong> para participar y realiza una compra con tu <strong>Tarjeta Éxito o Carulla Mastercard</strong> y sé uno de los primeros 1.500 clientes en recibir</p>`}
          desc={`<h2><b>1.000<br/>Puntos Colombia</b></h2>`}
          cta="¡Participa ahora!"
          image="logo_puntos_colombia.png"
          show={showAceleradorLogin}
          setShowModal={setShowAceleradorLogin}
        />
      )}
      {showTcModal && (
        <TCModal
          show={showTcModal}
          setShowModal={setShowTcModal}
          loading={!staticContent || Object.keys(staticContent).length === 0}
        />
      )}
      {showFaqsModal &&
        <FaqsModal
          show={showFaqsModal}
          setShowModal={setShowFaqsModal}
        />
      }

      <div className={`App ${modalOpen ? 'modalOpen' : ''} ${loggedIn ? 'loggedIn' : 'noLoggedIn'}`}>
        <Header
          headerType={1}
          logo="logos.svg"
          logo_mb="logos.svg"
          logo_mc="logo_mc.svg"
          logo_mc_mb="logo_mc_mb.svg"
          items={pages}
          submenu={false}
          notifications={
            [
              {
                id: 1,
                title: "Notification",
                content: "html content",
                status: 0
              }
            ]
          }
          loggedIn={loggedIn}
          logOutAction={logOutAction}
        />
        {!context && 
          <div className={`login_counter_down  ${scrolled ? 'static_banner' : ''}`}>
            {/*showCounterDown && 
              <CounterDown comercio={""}/>
            */}
          </div>
        }
        <Routes>
          <Route path="/login" element={<Login autologin={autologinPreloader} hash={searchParams.get('utm_web')} link={
            [
              {
                link: "/terminos-y-condiciones",
                text: "Términos y condiciones",
                onClick: handleTcModal
              }
            ]
          } />} />
          <Route path="/" element={<Navigate to="/progreso" replace />} />
          {pages.map((page, i) => {
            return (
              <Route
                key={i}
                path={`/${page.page}`}
                element={page.component}
              />
            )
          })}
          <Route path="/dashboard" element={<Dashboard adminPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer
          footerType={1}
          footerCardsImg="footer_cards.png"
          secondaryFooterImg="footer_cards.png"
          bankFooterImg="bank-footer.png"
          awardFooterImg="award.png"
          links={
            [
              {
                link: "/terminos-y-condiciones",
                text: "Términos y condiciones",
                onClick: handleTcModal 
              },
              {
                link: "/preguntas-frecuentes",
                text: "Preguntas frecuentes",
                onClick: handleFaqsModal
              }
            ]
          }
          content='<p>
              Campaña válida del 15 de abril al 15 de junio de 2026 y solo aplica para territorio colombiano. Desde TUYA te vamos a solicitar datos referentes al código que fue enviado a tu correo y a la fecha de nacimiento para habilitar tu ingreso a la plataforma de campaña. Esta campaña aplica para clientes con Tarjetas Éxito Básica Mastercard, Tarjetas Éxito Pro Mastercard, Tarjetas Éxito Gold Mastercard, Tarjetas Carulla Gold Mastercard o Tarjetas Carulla Mastercard Black que han sido seleccionados e invitados a participar en la campaña a través de comunicación enviada al correo o celular registrados. ¡OJO! TUYA nunca le pedirá contraseñas, pines, códigos, actualizar información o datos de tarjetas de pago. Recuerda que las únicas cuentas autorizadas de las que te llegará información son:
              <a href="mailto:Tarjetaexito@notificaciones.tuya.com.co"><strong>Tarjetaexito@notificaciones.tuya.com.co</strong></a> o 
              <a href="mailto:Tarjetacarulla@notificaciones.tuya.com.co"><strong>Tarjetacarulla@notificaciones.tuya.com.co</strong></a>.
            </p>

            <p>*Esta es una campaña oficial del Tuya S.A. Compañía de financiamiento.</p>
            <p>*Mastercard y el diseño de los círculos son marcas registradas de Mastercard International Incorporated.</p>

          '
          copyright="© Copyright 2025"
          logOutAction={logOutAction}
          loggedIn={loggedIn}
        />

      </div>
    </StateController.Provider>
  )
}

const mapState = ({ user: { fetching, loggedIn, token, error } }) => {
  return {
    fetching,
    loggedIn,
    token,
    error
  }
}

export default connect(mapState, { logOutAction, loginShaAction })(App)